import type { NavigationGuard } from "vue-router";

import { useBackUrl } from "@/composables";
import { useProductsStore } from "@/stores";

export function packageParameterGuard(): NavigationGuard {
  return async (to) => {
    const backUrl = useBackUrl(to);

    if (!to.query.package) {
      return backUrl.value;
    }

    const productsStore = useProductsStore();

    if (productsStore.status === "initial") {
      await productsStore.load();
    }

    const product = productsStore.products.find((p) => p.id === to.query.package);
    if (!product) {
      return backUrl.value;
    }
  };
}
